<template>
    <div>
        <CRow>
            <CCol col="12">
                <CCard>
                    <CCardHeader>
                        <strong>Создание товара</strong>
                    </CCardHeader>

                    <CCardBody>
                        <GoodsUpsertForm
                            @dismiss="$router.go(-1)"
                        />
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import GoodsUpsertForm from '@/components/grocers/GoodsUpsertForm'

    export default {
        name: 'GoodsCreate',

        components: {
            GoodsUpsertForm,
        },
    }
</script>

<style>

</style>
